import "./collapsible.css";
import { useState, useEffect, useRef, useMemo } from "react";

export default function Collapsible(props) {
    const { name } = props;

    const [open, setOpen] = useState(false);

    const contentRef = useRef(null);
    const rootRef = useRef(null);

    const symbol = useMemo(() => Symbol("collapsible"), []);

    const getParent = () => {
        return rootRef.current?.parentElement?.parentElement;
    }

    const inAccordeon = () => {
        return getParent()?.classList.contains('accordeon')
    }

    const toggleCollapsible = () => {
        setOpen(!open);

        if (inAccordeon()) {
            getParent().dispatchEvent(new CustomEvent('accordeon:open', {
                detail: { symbol }
            }))
        }
    };

    useEffect(() => {
        console.log(getParent())
        if (!inAccordeon()) {
            setOpen(props.open ?? false)
            return;
        }

        const handleCollapsibleSiblingOpening = (e) => {
            const { detail } = e;

            if (detail.symbol !== symbol) {
                setOpen(false);
            }
        };

        const parent = getParent();

        parent.addEventListener("accordeon:open", handleCollapsibleSiblingOpening)

        return () => {
            parent.removeEventListener("accordeon:open", handleCollapsibleSiblingOpening)
        }
    }, [symbol])

    useEffect(() => {
        if (contentRef.current && props.content) {
            contentRef.current.appendChild(props.content);
        }
    }, []);

    return (
        <div ref={rootRef} className="collapsible" data-open={open || undefined}>
            <button
                onClick={toggleCollapsible}
                className="collapsible-button"
                type="button"
            >
                <span dangerouslySetInnerHTML={{ __html: name}}></span>

                <svg
                    style={{
                        transition: "transform 200ms ease-in-out",
                        transform: open ? "rotate(0deg)" : "rotate(-180deg)",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={3}
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 15.75 7.5-7.5 7.5 7.5"
                    />
                </svg>
            </button>
            <div className="collapsible-content-wrapper" ref={contentRef}></div>
        </div>
    );
}
